// Analytics tracking utilities
export const trackStepCompleted = (stepName, data) => {
  console.log(`📊 Step completed: ${stepName}`, data);
  // TODO: Integrate with Firebase Analytics or other service
};

export const trackEvent = (eventName, properties) => {
  console.log(`📊 Event: ${eventName}`, properties);
};

